import { combineReducers } from "redux";
import authReducer from "./AuthReducer";
import MerchantReducer from "./MerchantReducer";
import TransactionReducer from "./TransactionReducer";
import insuranceReducer from "./InsuranceReducer";
import userManagementReducer from "./UserManagementReducer";
import dashbordReducer from "./DashboardReducer";
//import { reducer as formReducer } from "redux-form";

export default combineReducers({
    authReducer,
    MerchantReducer,
    TransactionReducer,
    insuranceReducer,
    userManagementReducer,
    dashbordReducer
    //form: formReducer
});